
export default {
    name: 'MenuButton',
    props: {
        active: {
            type: Boolean,
            default: () => false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
